import { Directive, ElementRef, Input, OnInit, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appLazyLoadImage]'
})
export class LazyLoadImageDirective implements OnInit, AfterViewInit {
  @Input() appLazyLoadImage: string | undefined;
  @Input() errorPlaceholder: string | undefined;
  private observer: IntersectionObserver;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.setPlaceholder(); 
    this.initializeObserver();
  }

  ngAfterViewInit(): void {
    this.observer.observe(this.el.nativeElement);
  }

  private initializeObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = this.el.nativeElement.querySelector("img") as HTMLImageElement;          
            if (this.appLazyLoadImage) {
              this.loadImage(img);
            }    

            this.observer.unobserve(entry.target); 
          }
        });
      },
      {
        root: null,              
        rootMargin: '0px',       
        threshold: 0.2,          
      }
    );
  }
  /** 
   * Author Rohan Kesarkar
   * Below method is used to preload image in background and after completion of preloading it is giving 
   * result of image is loaded successfully or gave error then after final result it will append real url 
   * of src tag so it will not give any flickering effect.
   */
  private loadImage(img: HTMLImageElement): void {
    const originalSrc = this.appLazyLoadImage;
    if (originalSrc) {
      const tempImg = new Image();
      tempImg.src = originalSrc;
      tempImg.onload = () => {
        img.src = originalSrc;
      };
      tempImg.onerror = () => {
        img.src = this.errorPlaceholder;
      };
    }
  }

  private setPlaceholder(): void {
    const img = this.el.nativeElement.querySelector("img") as HTMLImageElement;
    if (img && !img.src) {
      img.src = this.errorPlaceholder;
    }
  }
}
